import React from 'react';
import { SEOHead } from '@/components/SEOHead';

const Security = () => {
  return (
    <>
      <SEOHead
        title="Security Reports | Milky Way Planner"
        description="How to report a security issue on Milky Way Planner. Where to send a vulnerability report and what to include so it can be looked into."
        canonicalUrl="/security"
        noindex
      />
      <div className="min-h-screen bg-background">
        <section className="bg-slate-950 py-16 sm:py-20">
          <div className="max-w-3xl mx-auto px-4 sm:px-6 text-center">
            <span className="eyebrow text-gold-light mb-4 block">Legal</span>
            <h1 className="text-3xl md:text-4xl text-white tracking-[-0.03em] mb-4">
              Reporting a security issue
            </h1>
          </div>
        </section>

        <div className="max-w-6xl mx-auto px-4 sm:px-6 py-12">
          <div className="max-w-3xl space-y-8 leading-relaxed">
            <p className="text-muted-foreground">
              If you've found a security problem on Milky Way Planner, email support@milkywayplanner.com with the affected URL, what the issue is, and the steps to reproduce it.
            </p>
            <p className="text-muted-foreground">
              There's no bug bounty program, and I don't pay for reports. Reports that only paste automated scanner output, with no specific finding, may not get a reply.
            </p>
            <p className="text-muted-foreground">
              — Eric
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default Security;
